export default "__VITE_PUBLIC_ASSET__595e1f40__"